import React from 'react';

const Loading = () => (
    <div className='evaluation-loading'>
        <div className='small'>
            <div className='placeholder-shimmer'></div>
            <div className='placeholder-shimmer'></div>
        </div>
        <div className='small'>
            <div className='placeholder-shimmer'></div>
            <div className='placeholder-shimmer'></div>
        </div>
        <div className='big'>
            <div className='placeholder-shimmer'></div>
            <div className='placeholder-shimmer'></div>
            <div className='placeholder-shimmer'></div>
            <div className='placeholder-shimmer'></div>
        </div>
        <div className='small'>
            <div className='placeholder-shimmer'></div>
        </div>
    </div>
);

export default Loading;
